import { useEffect } from 'react';
import { useToast } from '../useToast';
import { Phrases } from '../../utilities/constants/phrases';
import { ToastType } from '../../components/Toast/Toast';

const ERROR_DURATION = 15000;

interface IUseEditorToastOptions {
  isTextGenerationSuccess?: boolean;
  error?: string | null;
}

export const useEditorToast = (options: IUseEditorToastOptions) => {
  const { isTextGenerationSuccess, error } = options;

  const { open } = useToast();

  useEffect(() => {
    if (isTextGenerationSuccess) {
      open(Phrases.TOAST_TEXT_GENERATED);
    }
    if (error) {
      open(error, ToastType.ERROR, ERROR_DURATION);
    }
  }, [isTextGenerationSuccess, error, open]);
};
